/** Deliverable types that are photo/static — UGC report boost is video/Reels only. */
const PHOTO_ONLY_DELIVERABLE_TYPES = new Set(['ugc_photo', 'instagram_post', 'facebook_post', 'twitter_post']);

const VIDEO_DELIVERABLE_TOKENS = [
    'reel',
    'video',
    'tiktok',
    'youtube',
    'short',
    'story',
    'vertical',
    'horizontal',
    'ugc_video',
];

export function isPhotoOnlyDeliverableType(deliverableType: string | undefined | null): boolean {
    const t = String(deliverableType || '')
        .trim()
        .toLowerCase();
    return Boolean(t) && PHOTO_ONLY_DELIVERABLE_TYPES.has(t);
}

export function isVideoLikeDeliverableType(deliverableType: string | undefined | null): boolean {
    const t = String(deliverableType || '')
        .trim()
        .toLowerCase();
    if (!t || isPhotoOnlyDeliverableType(t)) return false;
    return VIDEO_DELIVERABLE_TOKENS.some(token => t.includes(token));
}

/**
 * Whether the report content row can open the Meta Reels boost flow.
 * Photo-only deliverables are blocked client-side; missing type is allowed and the API validates video media.
 */
export function isCampaignReportBoostable(item: {
    submission_id?: string | null;
    deliverable_type?: string | null;
}): boolean {
    if (!item?.submission_id) return false;
    if (isPhotoOnlyDeliverableType(item.deliverable_type)) return false;
    return true;
}

export function getCampaignReportBoostDisabledReason(item: {
    submission_id?: string | null;
    deliverable_type?: string | null;
}): string | null {
    if (!item?.submission_id) return 'Submission required to boost';
    if (isPhotoOnlyDeliverableType(item.deliverable_type)) {
        return 'Boost is video-only (Meta Reels). Photo posts cannot be boosted here.';
    }
    return null;
}

/** Optional deep-link into AdHub after a boost draft is created. */
export function getAdHubCampaignReviewUrl(campaignId: string | undefined | null): string | null {
    const id = String(campaignId || '').trim();
    if (!id) return null;
    const base = (process.env.REACT_APP_ADHUB_APP_URL || process.env.REACT_APP_ADHUB_URL || '').replace(/\/$/, '');
    if (!base) return null;
    return `${base}/campaigns/${id}`;
}
